import { render, staticRenderFns } from "./group-i-join.vue?vue&type=template&id=dbea7724"
import script from "./group-i-join.vue?vue&type=script&lang=js"
export * from "./group-i-join.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports